export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5617.cdcddc2d.jpg";